import { useEffect, useState } from "react";
import Loader from "../../Components/Loader";
import { fetchClientData } from "../../Utilities/clientRequest";
import { withRouter } from "../../Utilities/withRouter";
import * as Styled from "./styled";

const Payment = ({ params }) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (params?.token && params?.order_id) {
      checkUser();
    } else {
      setMessage("Invalid payment session.");
    }
  }, [params]);

  const checkUser = async () => {
    setLoading(true);

    try {
      const res = await fetchClientData(
        params.token,
        "get",
        "client-auth/me"
      );

      if (res?.data) {
        initiatePayment(res.data);
      } else {
        setLoading(false);
        setMessage("Invalid or expired session.");
      }
    } catch (error) {
      setLoading(false);
      setMessage("Something went wrong.");
    }
  };

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const initiatePayment = async (userData) => {
    const sdkLoaded = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    setLoading(false);

    if (!sdkLoaded) {
      setMessage("Razorpay SDK failed to load.");
      return;
    }

    const options = {
      key: "rzp_live_SEOZ5ozLv4YDHR",
      amount: "50000",
      currency: "INR",
      name: "BathXpertz",
      description: "Project Payment",
      order_id: params.order_id,

      // 🔥 INSTANT SUCCESS
      handler: function (response) {

        // 🚀 Immediately notify Unity (NO WAIT)
        if (window.vuplex) {
          window.vuplex.postMessage(
            JSON.stringify({
              type: "PAYMENT_SUCCESS",
              orderId: response.razorpay_order_id,
              paymentId: response.razorpay_payment_id
            })
          );
        }

        // 🔐 Backend verification in background (fire & forget)
        const payload = {
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_order_id: response.razorpay_order_id,
          razorpay_signature: response.razorpay_signature,
        };

        fetchClientData(
          params.token,
          "post",
          "payments/payment-callback",
          payload
        ).catch(err => {
          console.error("Background verification failed", err);
        });
      },

      modal: {
        ondismiss: function () {
          if (window.vuplex) {
            window.vuplex.postMessage(
              JSON.stringify({
                type: "PAYMENT_FAILED"
              })
            );
          }
        },
      },

      prefill: {
        name: userData.name,
        email: userData.email,
        contact: userData.phone_number,
      },

      theme: {
        color: "#118D8B",
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  };

  return (
    <Styled.MainWrapDiv>
      <Loader loading={loading} />
      {message && <Styled.MessageDiv>{message}</Styled.MessageDiv>}
    </Styled.MainWrapDiv>
  );
};

export default withRouter(Payment);
